import React, { useState } from 'react';
import { Button, Modal, List, Typography } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import { PresetsItem } from '../../types/modelSettings';

const { Text } = Typography;

interface PromptPresetSelectorProps {
  presets?: PresetsItem | PresetsItem[];
  onSelectPreset: (prompt: string) => void;
  onAfterSelect?: () => void;
}

const PromptPresetSelector: React.FC<PromptPresetSelectorProps> = ({
  presets,
  onSelectPreset,
  onAfterSelect,
}) => {
  const presetsArray = presets ? (Array.isArray(presets) ? presets : [presets]) : [];
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSelectPreset = (prompt: string) => {
    onSelectPreset(prompt);
    setIsModalVisible(false);
    if (onAfterSelect) {
      onAfterSelect();
    }
  };

  return (
    <>
      <Button
        icon={<BookOutlined />}
        onClick={showModal}
        title="Choose prompt preset"
        style={{ marginLeft: 8 }}>
        Presets
      </Button>

      <Modal
        title="Select Prompt Preset"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}>
        {presetsArray.length > 0 ? (
          <List
            itemLayout="vertical"
            dataSource={presetsArray}
            renderItem={item => (
              <List.Item
                key={item.label}
                actions={[
                  <Button
                    key={`${item.label}-preset`}
                    type="primary"
                    onClick={() => handleSelectPreset(item.prompt)}>
                    Use this preset
                  </Button>,
                ]}>
                <List.Item.Meta title={item.label} />
                <div style={{ marginBottom: 16 }}>{item.prompt}</div>
              </List.Item>
            )}
          />
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Text type="secondary">No presets available for this model</Text>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PromptPresetSelector;
